import { render, staticRenderFns } from "./dialog-multi-checkbox-group-Two.vue?vue&type=template&id=4427f832&scoped=true&"
import script from "./dialog-multi-checkbox-group-Two.vue?vue&type=script&lang=js&"
export * from "./dialog-multi-checkbox-group-Two.vue?vue&type=script&lang=js&"
import style0 from "./dialog-multi-checkbox-group-Two.vue?vue&type=style&index=0&id=4427f832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4427f832",
  null
  
)

export default component.exports